import React from 'react';
import styles from './CustomButton.module.scss';
import Image from 'next/image';

const CustomButton = ({ label, icon,iconHeight, iconWidth,handleClick, type,sx, iconPosition="left"}) => {
  return (
    <button
      className={styles.customButton}
      type={type}
      style={{ ...sx }}
      onClick={
        handleClick
      }
    >
      {
        iconPosition ==="right" && <span>{label}</span>
      }
      {icon && <div className={styles.icon}
      style={{marginRight: iconPosition ==="right" ? "0" : "8px",
        marginLeft: iconPosition ==="left" ? "0" : "8px"
      }}
      >
        <Image src={icon} alt="icon" width={iconWidth ?? 24} height={ iconHeight ?? 24} />
        </div>}
      {
        iconPosition ==="left" && <span>{label}</span>
      }
    </button>
  );
};
export default CustomButton;
